<div class="history-page">
  <div class="history-container">
    <!-- Page header -->
    <div class="page-header">
      <div>
        <h1 class="page-title">History</h1>
        <p class="page-subtitle">All your URL submissions and their current status</p>
      </div>
      <a routerLink="/submit" class="btn btn-primary">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        Submit URLs
      </a>
    </div>

    <!-- Drip jobs -->
    <div class="drip-card" *ngIf="dripJobs.length > 0">
      <div class="drip-header">
        <h3 class="drip-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          Drip jobs ({{ dripJobs.length }})
        </h3>
        <span class="badge badge-primary">Running</span>
      </div>
      <div class="drip-list">
        <div class="drip-item" *ngFor="let job of dripJobs">
          <div class="drip-job">
            <span class="drip-label">{{ job.url || job.urls || 'Scheduled submission' }}</span>
            <span class="drip-countdown mono">{{ job.countdown || 'Calculating...' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Filters -->
    <div class="filters-bar">
      <div class="search-input">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input
          type="text"
          placeholder="Search URLs..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()"
        />
      </div>
      <select class="filter-select" [(ngModel)]="statusFilter" (change)="onFilterChange()">
        <option value="">All statuses</option>
        <option value="submitted">Indexed</option>
        <option value="pending">In queue</option>
        <option value="drip_scheduled">Drip scheduled</option>
        <option value="rejected">Failed</option>
      </select>
    </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-state">
      <div class="spinner spinner-lg"></div>
      <p>Loading history...</p>
    </div>

    <!-- Table -->
    <div *ngIf="!isLoading" class="table-wrapper">
      <table class="data-table" *ngIf="links.length > 0">
        <thead>
          <tr>
            <th style="width: 50%">URL</th>
            <th>Status</th>
            <th>Submitted</th>
            <th style="text-align: right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let link of links">
            <td>
              <div class="url-cell">
                <a class="url-text" (click)="openUrl(link.url)" title="{{ link.url }}">{{ truncUrl(link.url) }}</a>
              </div>
            </td>
            <td>
              <span class="status-badge" [class]="'status-' + link.status.toLowerCase()">
                <span class="status-dot" [class]="'dot-' + link.status.toLowerCase()"></span>
                {{ link.status }}
              </span>
            </td>
            <td class="time-cell">{{ formatDate(link.dateTime) }}</td>
            <td style="text-align: right">
              <button class="btn btn-icon btn-ghost" (click)="copyUrl(link.url)" title="Copy URL">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
              </button>
              <button class="btn btn-icon btn-ghost" (click)="openUrl(link.url)" title="Open URL">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="links.length === 0" class="empty-state">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" opacity="0.4"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        <h3>No submissions yet</h3>
        <p>Submit your first URL to see it appear here</p>
        <a routerLink="/submit" class="btn btn-primary">Submit URLs</a>
      </div>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="links.length > 0">
      <button class="btn btn-secondary btn-sm" (click)="loadMore()" [disabled]="!hasMore || isLoadingMore">
        <span class="spinner spinner-sm" *ngIf="isLoadingMore"></span>
        <span>{{ hasMore ? 'Load more' : 'No more results' }}</span>
      </button>
      <span class="pagination-info">Showing {{ links.length }} of {{ stats.total }}</span>
    </div>
  </div>
</div>

<!-- Toast -->
<div class="toast" *ngIf="toastMessage" [class]="toastType === 'success' ? 'success' : 'error'">
  {{ toastMessage }}
</div>
